/**
 * PaypoDetails – custom element wrapper for the paypo
 */
class PaypoDetails extends HTMLElement {}

if (!window.customElements.get('paypo-details')) {
  window.customElements.define('paypo-details', PaypoDetails);
} 